module.exports = __webpack_public_path__ + "img/ring_g_l_1_1@3x.451f7990.png";